import { CropConnectLanguages } from '../../services/cropConnectApiClient';

const languagesInPolish: { [key in CropConnectLanguages]: string } = {
  [CropConnectLanguages.None]: '-',
  [CropConnectLanguages.DaDA]: 'Duński',
  [CropConnectLanguages.DeDE]: 'Niemiecki',
  [CropConnectLanguages.EnGB]: 'Angielski',
  [CropConnectLanguages.FiFI]: 'Fiński',
  [CropConnectLanguages.LtLT]: 'Litewski',
  [CropConnectLanguages.PlPL]: 'Polski',
  [CropConnectLanguages.SkSK]: 'Słowacki',
  [CropConnectLanguages.SvSE]: 'Szwedzki',
};

export const languagesInSlovak: { [key in CropConnectLanguages]: string } = {
  [CropConnectLanguages.None]: '-',
  [CropConnectLanguages.DaDA]: 'Dánčina',
  [CropConnectLanguages.DeDE]: 'Nemčina',
  [CropConnectLanguages.EnGB]: 'Angličtina',
  [CropConnectLanguages.FiFI]: 'Fínčina',
  [CropConnectLanguages.LtLT]: 'Litovčina',
  [CropConnectLanguages.PlPL]: 'Poľština',
  [CropConnectLanguages.SkSK]: 'Slovenčina',
  [CropConnectLanguages.SvSE]: 'Švédčina',
};

export const languagesInSwedish: { [key in CropConnectLanguages]: string } = {
  [CropConnectLanguages.None]: '-',
  [CropConnectLanguages.DaDA]: 'Danska',
  [CropConnectLanguages.DeDE]: 'Tyska',
  [CropConnectLanguages.EnGB]: 'Engelska',
  [CropConnectLanguages.FiFI]: 'Finska',
  [CropConnectLanguages.LtLT]: 'Litauiska',
  [CropConnectLanguages.PlPL]: 'Polska',
  [CropConnectLanguages.SkSK]: 'Slovakiska',
  [CropConnectLanguages.SvSE]: 'Svenska',
};

export const languagesInDanish: { [key in CropConnectLanguages]: string } = {
  [CropConnectLanguages.None]: '-',
  [CropConnectLanguages.DaDA]: 'Dansk',
  [CropConnectLanguages.DeDE]: 'Tysk',
  [CropConnectLanguages.EnGB]: 'Engelsk',
  [CropConnectLanguages.FiFI]: 'Finsk',
  [CropConnectLanguages.LtLT]: 'Litauisk',
  [CropConnectLanguages.PlPL]: 'Polsk',
  [CropConnectLanguages.SkSK]: 'Slovakisk',
  [CropConnectLanguages.SvSE]: 'Svensk',
};

export const languagesInGerman: { [key in CropConnectLanguages]: string } = {
  [CropConnectLanguages.None]: '-',
  [CropConnectLanguages.DaDA]: 'Dänisch',
  [CropConnectLanguages.DeDE]: 'Deutsch',
  [CropConnectLanguages.EnGB]: 'Englisch',
  [CropConnectLanguages.FiFI]: 'Finnisch',
  [CropConnectLanguages.LtLT]: 'Litauisch',
  [CropConnectLanguages.PlPL]: 'Polnisch',
  [CropConnectLanguages.SkSK]: 'Slowakisch',
  [CropConnectLanguages.SvSE]: 'Schwedisch',
};

export const languagesInEnglish: { [key in CropConnectLanguages]: string } = {
  [CropConnectLanguages.None]: '-',
  [CropConnectLanguages.DaDA]: 'Danish',
  [CropConnectLanguages.DeDE]: 'German',
  [CropConnectLanguages.EnGB]: 'English',
  [CropConnectLanguages.FiFI]: 'Finnish',
  [CropConnectLanguages.LtLT]: 'Lithuanian',
  [CropConnectLanguages.PlPL]: 'Polish',
  [CropConnectLanguages.SkSK]: 'Slovak',
  [CropConnectLanguages.SvSE]: 'Swedish',
};

export const languagesInFinnish: { [key in CropConnectLanguages]: string } = {
  [CropConnectLanguages.None]: '-',
  [CropConnectLanguages.DaDA]: 'Tanska',
  [CropConnectLanguages.DeDE]: 'Saksa',
  [CropConnectLanguages.EnGB]: 'Englanti',
  [CropConnectLanguages.FiFI]: 'Suomi',
  [CropConnectLanguages.LtLT]: 'Liettua',
  [CropConnectLanguages.PlPL]: 'Puola',
  [CropConnectLanguages.SkSK]: 'Slovakia',
  [CropConnectLanguages.SvSE]: 'Ruotsi',
};

export const languagesInLithuanian: { [key in CropConnectLanguages]: string } =
  {
    [CropConnectLanguages.None]: '-',
    [CropConnectLanguages.DaDA]: 'Danų',
    [CropConnectLanguages.DeDE]: 'Vokiečių',
    [CropConnectLanguages.EnGB]: 'Anglų',
    [CropConnectLanguages.FiFI]: 'Suomių',
    [CropConnectLanguages.LtLT]: 'Lietuvių',
    [CropConnectLanguages.PlPL]: 'Lenkų',
    [CropConnectLanguages.SkSK]: 'Slovakų',
    [CropConnectLanguages.SvSE]: 'Švedų',
  };

export const originalLanguageNames: { [key in CropConnectLanguages]: string } =
  {
    [CropConnectLanguages.None]: '-',
    [CropConnectLanguages.DaDA]: 'Dansk',
    [CropConnectLanguages.DeDE]: 'Deutsch',
    [CropConnectLanguages.EnGB]: 'English',
    [CropConnectLanguages.FiFI]: 'Suomi',
    [CropConnectLanguages.LtLT]: 'Lietuvių',
    [CropConnectLanguages.PlPL]: 'Polski',
    [CropConnectLanguages.SkSK]: 'Slovenský',
    [CropConnectLanguages.SvSE]: 'Svenska',
  };

export const getLanguagesByUserLanguage = (
  userLanguage: CropConnectLanguages
): { [key in CropConnectLanguages]: string } => {
  switch (userLanguage) {
    case CropConnectLanguages.DaDA:
      return languagesInDanish as { [key in CropConnectLanguages]: string };
    case CropConnectLanguages.DeDE:
      return languagesInGerman as { [key in CropConnectLanguages]: string };
    case CropConnectLanguages.EnGB:
      return languagesInEnglish as { [key in CropConnectLanguages]: string };
    case CropConnectLanguages.FiFI:
      return languagesInFinnish as { [key in CropConnectLanguages]: string };
    case CropConnectLanguages.LtLT:
      return languagesInLithuanian as { [key in CropConnectLanguages]: string };
    case CropConnectLanguages.PlPL:
      return languagesInPolish as { [key in CropConnectLanguages]: string };
    case CropConnectLanguages.SkSK:
      return languagesInSlovak as { [key in CropConnectLanguages]: string };
    case CropConnectLanguages.SvSE:
      return languagesInSwedish as { [key in CropConnectLanguages]: string };
    default:
      return languagesInEnglish as { [key in CropConnectLanguages]: string };
  }
};
